export default function PageHeader({ title, subtitle, children }) {
  return (
    <div className="stratus-page-header">
      <div>
        <div className="stratus-page-title" data-testid="page-title">{title}</div>
        {subtitle && <div className="stratus-page-sub">{subtitle}</div>}
      </div>
      {children && <div className="stratus-actions">{children}</div>}
    </div>
  );
}
